import Splide from '@splidejs/splide';

const initCarousel = () => {
  const carouselWrapper = document.querySelector('.js-carousel');

  if (!carouselWrapper) return;

  const carousel = new Splide(carouselWrapper, {
    type: 'loop',
    autoWidth: true,
    autoplay: true,
    interval: 2000,
    arrows: false,
    pagination: false,
  });

  carousel.mount();
};

export default initCarousel;



// WEBPACK FOOTER //
// ./src/scripts/modules/carousel.js